module.exports = __webpack_public_path__ + "img/center.e6850e37.png";